import { configureStore } from '@reduxjs/toolkit';
import { feedApi } from '../features/api/feedApi';
import { tagsApi } from '../features/api/tagsApi';
import { tenantsApi } from '../features/api/tenantsApi';
import { staffApi } from '../features/api/staffApi';
import authReducer from './modules/auth/reducer';
import userReducer from './modules/user/reducer';
import commonReducer from './modules/common/reducer';
import buildingsReducer from './modules/buildings/reducer';
import tagsReducer from './modules/tags/reducer';
import billingReducer from './modules/billing/reducer';
import feedReducer from './modules/feed/reducer';
import drawerReducer from './modules/drawer/reducer';
import tenantsReducer from './modules/tenants/reducer';
import analyticsReducer from './modules/analytics/reducer';

// Create the store with RTK Query middleware
const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    common: commonReducer,
    buildings: buildingsReducer,
    tags: tagsReducer,
    billing: billingReducer,
    feed: feedReducer,
    drawer: drawerReducer,
    tenants: tenantsReducer,
    analytics: analyticsReducer,
    [feedApi.reducerPath]: feedApi.reducer,
    [tagsApi.reducerPath]: tagsApi.reducer,
    [tenantsApi.reducerPath]: tenantsApi.reducer,
    [staffApi.reducerPath]: staffApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false // Disable immutable state checks
    }).concat(feedApi.middleware, tagsApi.middleware, tenantsApi.middleware, staffApi.middleware),
  devTools: process.env.NODE_ENV !== 'production'
});

export default store;